import React from 'react'
import { hotjar } from 'react-hotjar'
import { env } from 'env.client'

export const HotJarProvider = ({ children }: { children: React.ReactNode }) => {
  React.useEffect(() => {
    if (env.NEXT_PUBLIC_HOTJAR_SITE_ID) {
      hotjar.initialize({ id: env.NEXT_PUBLIC_HOTJAR_SITE_ID, sv: 6 })
    }
  }, [])

  return <>{children}</>
}
